import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

function JobTimeline() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div className="h-screen bg-adminbg p-4 contentAdmin" style={{ fontFamily: "Inter, sans-serif" }}>
      <div className="">
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Timeline (in Years)
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen}
              >
                Add<i class="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent maxW={"2xl"}>
                  <div className="p-4">
                    <h4 className="py-2">Add Timeline:</h4>
                    <Input
                      className="border-black"
                      color="black"
                      placeholder=""
                      _placeholder={{ color: "" }}
                    />
                    <div className="w-full flex justify-center gap-2 mt-5">
                      <Button colorScheme="blue" className="w-64">
                        Save
                      </Button>
                      <Button
                        colorScheme="blue"
                        textColor={"blue"}
                        variant={"outline"}
                        className="w-64"
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </ModalContent>
              </Modal>
            </div>
          </div>
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">ID</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action </Th>
                </Tr>
              </Thead>
              <Tbody flex={"col"} gap={"100px"}>
                <Tr>
                  <Td>1</Td>
                  <Td>0-1</Td>
                  <Td textColor={"green"}>Active</Td>
                  <Td>
                    <div className=" text-sm opacity-90 text-blue-700">
                      <i class="fa-solid fa-eye mr-3.5 "></i>
                      <i class="fa-solid fa-pencil mr-3.5 "></i>
                      <i class="fa-solid fa-trash-can-arrow-up mr-3.5 "></i>
                    </div>
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobTimeline;
